import { Box } from '@mantine/core';
import { Link } from 'react-router-dom';

export function BetaFooter() {
  const year = new Date().getFullYear();
  return (
    <Box component="footer" className="beta-footer">
      <div className="beta-footer-inner">
        <span>
          © {year} PokeBinder
        </span>
        <nav className="beta-footer-links" aria-label="Footer">
          <Link
            to="/mcp"
            title="Connect Claude and other AI assistants to your collection"
          >
            MCP
          </Link>
          <Link to="/bulk-entry" title="Add a whole set to your collection at once">
            Bulk entry
          </Link>
          <Link to="/scanner" title="Scan a card with your camera or upload a photo">
            Scan
          </Link>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
        </nav>
      </div>
    </Box>
  );
}
